import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { WorkspaceStatus } from '../models/agent';

export const WorkspaceAgentFetch = createAction('[WorkspaceAgent] Fetch', props<{ workspaceId: string }>());
export const WorkspaceAgentFetched = createAction(
  '[WorkspaceAgent] Fetched',
  props<{ workspaceId: string; workspaceAgent: WorkspaceStatus }>()
);
export const WorkspaceAgentError = createAction('[WorkspaceAgent] Error', props<{ workspaceId: string }>());

export const initialState: Record<string, CommonApiState<WorkspaceStatus>> = {};

export const workspaceAgentFeature = createFeature({
  name: 'workspaceAgent',
  reducer: createReducer(
    initialState,
    on(WorkspaceAgentFetch, (state, action) => ({
      ...state,
      [action.workspaceId]: {
        ...(state[action.workspaceId] ?? {}),
        currentPedingApis: (state[action.workspaceId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(WorkspaceAgentFetched, (state, action) => {
      return {
        ...state,
        [action.workspaceId]: {
          ...(state[action.workspaceId] ?? {}),
          currentPedingApis: 0,
          data: action.workspaceAgent
        }
      };
    }),
    on(WorkspaceAgentError, (state, action) => {
      return {
        ...state,
        [action.workspaceId]: {
          ...(state[action.workspaceId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectWorkspaceAgentState }) => {
    const workspaceAgentIsLoading = (workspaceId: string) =>
      createSelector(
        selectWorkspaceAgentState,
        workspaceAgentsState => (workspaceAgentsState[workspaceId]?.currentPedingApis ?? 0) > 0
      );

    const workspaceAgentHasPendingRequest = (workspaceId: string) =>
      createSelector(
        selectWorkspaceAgentState,
        workspaceAgentsState => (workspaceAgentsState[workspaceId]?.currentPedingApis ?? 0) >= 2
      );
    const workspaceAgentData = (workspaceId: string) => {
      return createSelector(selectWorkspaceAgentState, workspaceAgentState => {
        return workspaceAgentState[workspaceId]?.data;
      });
    };
    const workspaceAgentIsError = (workspaceId: string) => {
      return createSelector(selectWorkspaceAgentState, workspaceAgentState => {
        return workspaceAgentState[workspaceId]?.isError;
      });
    };

    return {
      workspaceAgentIsLoading,
      workspaceAgentIsError,
      workspaceAgentHasPendingRequest,
      workspaceAgentData
    };
  }
});
